import { Action, getModule, Module, Mutation } from 'vuex-module-decorators';

import store from '@/store';
import EntityBaseModule from '@/store/entity';
import ResponseHandlerModule from '@/store/modules/responseHandler';

import { Doctors } from '@/models/doctors';
import { DoctorApiCard, DoctorModel } from '@/types/models/doctors';

import { addNewEntity, getById, removeEntity, updateEntity } from '@/api/crud';

import EntityModel from './entityModel';
import { activateDoctor, deactivateDoctor } from '@/api/doctors';

export const MODULE_NAME = Doctors.moduleEntityName;

@Module({ dynamic: true, store, name: MODULE_NAME, namespaced: true })
class DoctorEntityModule extends EntityBaseModule {
    model: DoctorModel;
    doctorDetail: DoctorApiCard | null;
    typesList: any;

    constructor(module: DoctorEntityModule) {
        super(module);

        const entityModel = new EntityModel();
        this.model = entityModel.model;
        this.doctorDetail = null;
    }

    @Mutation
    SET_DOCTOR_DETAIL(value: DoctorApiCard) {
        this.doctorDetail = value;
    }

    @Action({ rawError: true })
    async getById(id: string): Promise<DoctorApiCard> {
        try {
            const result = await getById(Doctors.moduleName, id);

            this.SET_DOCTOR_DETAIL(result.doctor);

            return result.doctor;
        } catch (clientError) {
            const error = clientError.response.data;

            throw new Error(error.message);
        }
    }

    @Action({ rawError: true })
    async createNew(data: Record<string, any>) {
        try {
            return addNewEntity(Doctors.moduleName, data);
        } catch (error) {
            if (error.response?.data) {
                ResponseHandlerModule.showNotify({ message: error.response.data, type: 'fail' });

                return;
            }
            ResponseHandlerModule.showNotify({ message: error, type: 'fail' });
        }
    }

    @Action({ rawError: true })
    async update(params: { id: string; data: Record<string, any> }) {
        try {
            return updateEntity(Doctors.moduleName, params.id, params.data);
        } catch (error) {
            if (error.response?.data) {
                ResponseHandlerModule.showNotify({ message: error.response.data, type: 'fail' });
                return;
            }
            ResponseHandlerModule.showNotify({ message: error, type: 'fail' });
        }
    }

    @Action({ rawError: true })
    remove (id: string) {
        return removeEntity(Doctors.apiPrefix, id);
    }

    @Action({ rawError: true })
    async activate(id: string) {
        try {
            await activateDoctor(id);
        } catch (error) {
            if (error.response?.data) {
                ResponseHandlerModule.showNotify({ message: error.response.data, type: 'fail' });
                return;
            }
            ResponseHandlerModule.showNotify({ message: error, type: 'fail' });
        }
    }

    @Action({ rawError: true })
    async deactivate(id: string) {
        try {
            await deactivateDoctor(id);
        } catch (error) {
            if (error.response?.data) {
                ResponseHandlerModule.showNotify({ message: error.response.data, type: 'fail' });
                return;
            }
            ResponseHandlerModule.showNotify({ message: error, type: 'fail' });
        }
    }

    @Action({ rawError: true })
    async getIsActive(id: string) {
        try {
            const result = await this.getById(id);
            return result.isActive;
        } catch (error) {
            if (error.response?.data) {
                ResponseHandlerModule.showNotify({ message: error.response.data, type: 'fail' });
                return;
            }
            ResponseHandlerModule.showNotify({ message: error, type: 'fail' });
        }
    }
}

export default getModule(DoctorEntityModule);
